import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import  { useRef, useState } from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import slide1 from '../img/pexels-dina-nasyrova-3628062.jpg';
import slide2 from '../img/pexels-suzy-hazelwood-1223180.jpg';
import slide3 from '../img/pexels-markus-spiske-191157.jpg';
import slide4 from '../img/pexels-timothy-grindall-4058882.jpg';
import slide5 from '../img/pexels-malanca-stanislav-9080421.jpg'


function Slider(){

  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty('--progress', 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  }
    return(
       <>
     <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        modules={[Autoplay, Pagination, Navigation]}
        onAutoplayTimeLeft={onAutoplayTimeLeft}
        className="mySwiper"
      >
        
        <SwiperSlide>
        <div class="card align-middle">
          <img src={slide1} class="card-img"/>
          <div class="card-img-overlay d-flex flex-column justify-content-center align-items-center">
            <h3 class="card-title fw-bold text-white p-4">Colorful Wellness Palette</h3>
            <p class="card-text fw-light text-white">Experience a burst of health and vibrancy with our diverse range of colorful fruits.<br/> Each piece is a brushstroke of wellness, painting your life with nutrition and joy</p>
            <button className="btn-bg">Buy Now</button>
          </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div class="card align-middle">
          <img src={slide2} class="card-img"/>
          <div class="card-img-overlay d-flex flex-column justify-content-center align-items-center">
            <h3 class="card-title fw-bold text-white p-4">Pure Juicy Happiness</h3>
            <p class="card-text fw-light text-white">Happiness is just a bite away with our juiciest fruits.<br/> Taste the simple joy of nature in every piece.</p>
            <button className="btn-bg">Buy Now</button>
          </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div class="card align-middle">
          <img src={slide3} class="card-img"/>
          <div class="card-img-overlay d-flex flex-column justify-content-center align-items-center">
            <h3 class="card-title fw-bold text-white p-4">Tropical Treats, Anytime</h3>
            <p class="card-text fw-light text-white">Escape with our tropical delights. <br/>A taste of paradise, conveniently delivered to your doorstep.</p>
            <button className="btn-bg">Buy Now</button>
          </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div class="card align-middle">
          <img src={slide4} class="card-img"/>
          <div class="card-img-overlay d-flex flex-column justify-content-center align-items-center">
            <h3 class="card-title fw-bold text-white p-4">Seasonal Freshness</h3>
            <p class="card-text fw-light text-white">Celebrate the seasons with our fresh picks.<br/> From farm to table, simple goodness in every season</p>
            <button className="btn-bg">Buy Now</button>
          </div>
        </div>
        </SwiperSlide>
        <SwiperSlide>
        <div class="card ">
          <img src={slide5} class="card-img"/>
          <div class="card-img-overlay d-flex flex-column justify-content-center align-items-center">
            <h3 class="card-title fw-bold text-white p-2">Farm-Fresh Harvest</h3>
            <p class="card-text fw-light text-white">Embark on a journey of flavor and freshness.<br/> Our fruits, straight from the farm to your plate, promise a burst of natural goodness.</p>
            <button className="btn-bg">Buy Now</button>
          </div>
        </div>
        </SwiperSlide>
        <div className="autoplay-progress" slot="container-end">
          <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20"></circle>
          </svg>
          <span ref={progressContent}></span>
        </div>
      </Swiper>
       </>
    );
}
export default Slider;